export const additionalDataGrossListEnum = Object.freeze({
  YESNO: 'yesno',
  TEXT: 'text',
  PHONENUMBER: 'phonenumber',
});
